var map = {
	"./add.svg": 5327,
	"./ask.svg": 73577,
	"./askpaper.svg": 68373,
	"./banner.svg": 89540,
	"./book.svg": 42505,
	"./catalog.svg": 3751,
	"./clock.svg": 80024,
	"./comment.svg": 88457,
	"./course.svg": 93065,
	"./dataquery.svg": 68582,
	"./down.svg": 71082,
	"./excel.svg": 30131,
	"./feedback.svg": 10487,
	"./help.svg": 18371,
	"./home.svg": 61603,
	"./id.svg": 42265,
	"./idea.svg": 91195,
	"./img.svg": 35887,
	"./kpi.svg": 38436,
	"./learn.svg": 63496,
	"./metting.svg": 71700,
	"./my.svg": 57240,
	"./org.svg": 92404,
	"./plan.svg": 36327,
	"./poster.svg": 653,
	"./press.svg": 71263,
	"./raise.svg": 27894,
	"./ring.svg": 56796,
	"./run.svg": 55437,
	"./setting.svg": 86318,
	"./sms.svg": 53885,
	"./station.svg": 97798,
	"./tag.svg": 81746,
	"./task.svg": 63289,
	"./up.svg": 25849,
	"./upload.svg": 53497,
	"./user.svg": 52371,
	"./users.svg": 59674,
	"./walk.svg": 37405,
	"./word.svg": 29390,
	"./write.svg": 58811,
	"./write2.svg": 75427
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72922;